var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#26C6DA",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "93.467px",
    height: "93.467px",
    viewBox: "0 0 93.467 93.467",
    style: {
      enableBackground: "new 0 0 93.467 93.467"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.079,
    cy: 10.428,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.419,
    cy: 10.428,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.047,
    cy: 10.428,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.388,
    cy: 10.428,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.079,
    cy: 34.905,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.419,
    cy: 34.905,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.047,
    cy: 34.905,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.388,
    cy: 34.905,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.079,
    cy: 58.902,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.419,
    cy: 58.902,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.047,
    cy: 58.902,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.388,
    cy: 58.902,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.079,
    cy: 83.038,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.419,
    cy: 83.038,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.047,
    cy: 83.038,
    r: 7.079
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.388,
    cy: 83.038,
    r: 7.079
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSquare);
export default __webpack_public_path__ + "static/media/dots-square.fd6eb60c51453880cb03104669f50df6.svg";
export { ForwardRef as ReactComponent };